import React from "react";
import PropTypes from 'prop-types';
import axios from 'axios';
import NewsList from './NewsList';
import { get } from './Storage';
import cookie from 'react-cookie';
import css from '../topnews.less';
var AppSettings = get();

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            errorMessage: "",
            news: {}
        }
        this.loadNews = this.loadNews.bind(this);
    }

    componentDidMount(){
        let isBlocked = false;
        if(AppSettings.stopapicalendar != undefined && AppSettings.stopapicalendar != ""){
            isBlocked = this.checkBlockApi(AppSettings.stopapicalendar);
        }

        if(!isBlocked){
            this.loadNews(); 
        }            
    }

    checkBlockApi(value) {
        let isBlocked = false;
        try{
            const timeBlocks = value.split('|');
            for (let block of timeBlocks){
                if(block !== ""){
                    const [blockDay, startTimeBlock, endTimeBlock] = block.split(',');
                    if(blockDay == null || startTimeBlock == null || endTimeBlock == null){
                        continue; 
                    }

                    let now = new Date();
                    let start = new Date();
                    const[hs, ms] = startTimeBlock.split(':');
                    start.setHours(hs);
                    start.setMinutes(ms);

                    let end = new Date();
                    const[he, me] = endTimeBlock.split(':');
                    end.setHours(he);
                    end.setMinutes(me);
                    
                    if((start instanceof Date && isNaN(start))|| (end instanceof Date && isNaN(end))){
                        continue;
                    }

                    if(now.getDay() === parseInt(blockDay) && now >= start && now <= end){
                        isBlocked = true;
                        break;
                    }
                }
            }
        }
        catch(e){
            console.log(e);
            isBlocked = false;
        }
        return isBlocked;
    }

    componentWillUnmount() {
    }

    // Elimia le news già lette
    filterNews(news) {
        var selectedNews = [];
        for (var i = 0; i < news.length; i++) {
            if (typeof (Storage) !== "undefined") {
                var sessionName = AppSettings['env'].sessionName + "_" + news[i].id;
                if (sessionStorage.getItem(sessionName)== undefined) {
                    selectedNews.push(news[i])
                }
            }
            else {
                var cookieName = AppSettings['env'].cookieName + "_" + news[i].id;
                // Se è stata già letta la escludo
                if (cookie.load(cookieName) == undefined) {
                    selectedNews.push(news[i])
                }
            }
        }
        return selectedNews;
    }

    loadNews() {

        // Se nello storage locale ho un archivio di news evito la chiamata AJAX
        if (typeof (Storage) !== "undefined") {
            var data = sessionStorage.getItem(AppSettings['env'].localStorageName.name);
            if (data) {
                data = JSON.parse(data);
                if (data.username != AppSettings.username || Date.now() >= data.expire) {
                    sessionStorage.removeItem(AppSettings['env'].localStorageName.name);
                }
                else {
                    var selectedNews = this.filterNews(data.news);
                    this.setState({
                        news: selectedNews,
                        error: false
                    });
                    return true;
                }
            }
        }

        var url = AppSettings['env'].urlGetNews;
        axios.get(url)
            .then(({ data, status, statusText }) => {

                if (data.errors.length == 0) {
                    var news = this.filterNews(data.news);
                    if (typeof (Storage) !== "undefined") {
                        var expire = Date.now() + AppSettings['env'].localStorageName.lifeTime;
                        sessionStorage.setItem(AppSettings['env'].localStorageName.name, JSON.stringify({ username: AppSettings.username, expire: expire, news: data.news }));
                    }

                    this.setState({
                        news: news,
                        error: false
                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: "La tua sessione è scaduta",
                        news: {},
                    });
                }
            })
            .catch(({ data, status, statusText }) => {
                this.setState({
                    error: true,
                    errorMessage: "",
                    news: {},
                });
            });
    }


    render() {
        var newsList = "";
        if (this.state.news.length > 0) {
            newsList = <div className="topnews-container">
                <NewsList data={this.state.news} />
            </div>;
        }
        return <div>{newsList}</div>;
    }

    getChildContext() {
        return {
            reloadNews: this.loadNews
        };
    }
}

App.displayName = "AppComponents";

// PropTypes validation
App.propTypes = {

};

// default props
App.defaultProps = {
};

// Definizione
App.childContextTypes = {
    reloadNews: PropTypes.func
}

export default App;